import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function HPDashboardTouchpad() {
  const state = useContext(MainContext).state;
  const re = state.RE.split(',');

  let pcbaStatus = '?';
  switch (re[38]) {
    case '0': pcbaStatus = 'Slave I2C not used'; break;
    case '1': pcbaStatus = 'Slave I2C OK'; break;
    case '2': pcbaStatus = 'Slave I2C working'; break;
    case '3': pcbaStatus = 'Slave I2C timeout'; break;
  }

  let warningsStatus = 'None';
  const warningMap = {
    10: 'Ambient thermistor',
    11: 'Condenser thermistor',
    12: 'Water flow',
    13: 'Low pressure',
    14: 'High pressure',
    15: 'Compressor',
    16: 'Heat exchanger',
    17: 'Compressor thermistor'
  };
  if (warningMap[re[23]]) warningsStatus = warningMap[re[23]];

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>

      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item>
          <Typography
            component="h2"
            variant="h6"
            sx={{ color: 'white', fontWeight: 600 }}
          >
            {state.deviceName}
          </Typography>
        </Grid>

        <Grid item>
          <Chip
            icon={<SignalCellularAltOutlinedIcon />}
            label={`${state.rssi} dB`}
            size="small"
            sx={{
              bgcolor: 'rgba(76,175,80,0.18)',
              border: '1px solid rgba(76,175,80,0.5)',
              color: 'white',
              '& .MuiChip-icon': { color: 'rgba(129,199,132,1)' }
            }}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          alignItems: 'center',
          gap: 1.5
        }}
      >
        <Chip
          icon={<MemoryOutlinedIcon />}
          label={`V${re[1]}`}
          sx={{
            bgcolor: 'rgba(144,202,249,0.15)',
            border: '1px solid rgba(144,202,249,0.4)',
            color: '#90CAF9',
            fontWeight: 600,
            fontSize: 13
          }}
        />

        <Chip
          icon={<InfoOutlinedIcon />}
          label={re[40] || 'Unknown Model'}
          sx={{
            bgcolor: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.15)',
            color: 'white',
            fontSize: 13
          }}
        />

        {re[1] === '2' && (
          <Chip
            icon={<MemoryOutlinedIcon />}
            label={`PCBA: ${pcbaStatus}`}
            sx={{
              bgcolor: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.15)',
              color: 'white',
              mt: 0.5,
              fontSize: 12
            }}
          />
        )}
      </Box>

      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{
            pt: 3,
            color: 'rgba(255,255,255,0.7)',
            fontSize: 16,
            letterSpacing: 1,
          }}
        >
          Warnings / Faults
        </Typography>

        {warningsStatus !== 'None' ? (
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              flexWrap: 'wrap',
              gap: 0.75,
            }}
          >
            {warningsStatus.split('|').map((warn, index) => (
              <Chip
                key={index}
                label={warn.trim()}
                size="small"
                sx={{
                  bgcolor: 'rgba(255,255,255,0.06)',
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: 11,
                  height: 22,
                }}
              />
            ))}
          </Box>
        ) : (
          <Typography
            sx={{
              mt: 0.5,
              color: 'rgba(255,255,255,0.7)',
              fontSize: 13,
            }}
          >
            None
          </Typography>
        )}
      </Box>
    </Box>
  );
}
